import React from 'react';
import { Typography } from '@scale/scaleui';
import { MultiTurnInteractionConfiguration } from '@scale/shared/types/chat';
import StepSublistEditor from '../components/StepSublistEditor';
import { StepSection } from '../v2/constants';
import { IChatTaskFeatureConfig } from '@scale/shared/types/config';

type AfterStepsProps = {
  value: MultiTurnInteractionConfiguration;
  onSubmit: (config: MultiTurnInteractionConfiguration) => void;
  displayMLQualitySettings?: boolean;
  setForHeader?: boolean;
  navProps?: {
    currentSection?: StepSection;
    currentFieldId?: string;
  };
  setNavProps?: React.Dispatch<
    React.SetStateAction<{
      currentSection?: StepSection;
      currentFieldId?: string;
    }>
  >;
  chatTaskFeatureConfig?: IChatTaskFeatureConfig;
};

const AfterSteps = ({
  value,
  onSubmit,
  setForHeader,
  navProps,
  setNavProps,
  chatTaskFeatureConfig,
}: AfterStepsProps) => {
  return (
    <div className="flex flex-col gap-2">
      <Typography.H3>After Steps</Typography.H3>
      <Typography.Paragraph2 color="text-neutral-500">
        Steps in this section are run after the chat session completes.
      </Typography.Paragraph2>
      <StepSublistEditor
        value={value}
        onSubmit={onSubmit}
        property="after"
        setForHeader={setForHeader}
        navProps={navProps}
        setNavProps={setNavProps}
        chatTaskFeatureConfig={chatTaskFeatureConfig}
      />
    </div>
  );
};

export default AfterSteps;
